import User from '../types/User';
import * as types from '../actions/actionTypes';
import { ActionPayloadType } from '../types/ActionPayloadType'

const initialLoggedInUserState: User | null = null;

export default function loggedInUserReducer(state = initialLoggedInUserState, action: ActionPayloadType): User | null {
  switch (action.type) {
    case types.LOAD_LOGGED_USER_SUCCESS:
      return action.user ?? null;

    case types.LOGOUT_USER_SUCCESS:
      return null;

    default:
      return state;
  }
}
